import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 1, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.15, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`font-mono text-[10px] sm:text-xs tracking-[0.35em] uppercase text-gold/80 ${className}`}>
    {children}
  </p>
);

export const Veil = () => (
  <div aria-hidden className="relative h-px" data-testid="section-veil">
    <div className="absolute inset-x-0 -top-32 h-64 pointer-events-none bg-gradient-to-b from-transparent via-black/50 to-transparent" />
    <motion.div
      className="absolute left-1/2 -translate-x-1/2 top-0 h-px w-48 origin-center bg-gradient-to-r from-transparent via-gold/60 to-transparent"
      initial={{ scaleX: 0, opacity: 0 }}
      whileInView={{ scaleX: 1, opacity: 1 }}
      viewport={{ once: false, margin: "-80px" }}
      transition={{ duration: 1.6, ease: EASE }}
    />
  </div>
);

export const SectionHeading = ({ eyebrow, title, className = "" }) => (
  <div className={className}>
    <Reveal>
      <Eyebrow>{eyebrow}</Eyebrow>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.08] text-ivory text-balance">
        {title}
      </h2>
    </Reveal>
  </div>
);
